import cx from 'classnames';
import { centsToDollar } from '@utils/currency';
import typography from '~styles/typography.scss';
import type { FinancesEarningsByTableRow } from './apiHelpers';
import styles from './EarningsByTable.scss';

export interface EarningsByTableProps {
  rows: FinancesEarningsByTableRow[];
}

export const EarningsByTable = ({ rows }: EarningsByTableProps) => (
  <section className={styles.card}>
    <header className={styles.header}>
      <h3 className={cx(typography.h5, styles.title)}>Earnings by table</h3>
      <span className={cx(typography.c3, styles.meta)}>Top 10</span>
    </header>

    <table className={styles.table}>
      <thead>
        <tr>
          <th className={typography.t2}>Table</th>
          <th className={typography.t2}>Total</th>
          <th className={typography.t2}>Avg</th>
          <th className={typography.t2}># Sold</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td className={styles.emptyState} colSpan={4}>
              No earnings for this period
            </td>
          </tr>
        ) : (
          rows.slice(0, 10).map((row) => (
            <tr key={row.tableName}>
              <td className={typography.t3}>{row.tableName}</td>
              <td className={typography.t3}>{centsToDollar(row.total)}</td>
              <td className={typography.t3}>
                {centsToDollar(row.averageCover)}
              </td>
              <td className={typography.t3}>{row.countSold}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </section>
);
